export enum GiftCardTransferStateEnum {
  ALL = 'all',
  PROCESSED = 'processed',
  NOT_PROCESSED = 'notProcessed'
}
